// extracted by mini-css-extract-plugin
export default {"root":"iPKNz","emptyStateTitle":"A_C0I","emptyStateCaption":"LUCvp"};